// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"727":"05751b13","805":"9ecce2cf"}[chunkId] + ".chunk.css";
};